import api from "./api";

class EnumsServices {
    getGenders() {
        return api.get("/enums/genders");
    }
    getMaritalStatus() {
        return api.get("/enums/marital-status");
    }
    getAcademicsLevels() {
        return api.get("/enums/academics-levels");
    }
    getAcademicsInstitutions() {
        return api.get("/enums/academics-institutions");
    }
}

export default new EnumsServices();